import React, { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

const CounterSection: React.FC = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [count, setCount] = useState<number>(() => {
    const savedCount = localStorage.getItem("currentCount");
    return savedCount ? parseInt(savedCount, 10) : 5000000; 
  });

  useEffect(() => {
    const targetCount = 7000000;
    const duration = 2 * 60 * 60 * 1000; 
    const totalSteps = (targetCount - count) || (targetCount - 5000000);
    const stepDuration = duration / totalSteps;

    const interval = setInterval(() => {
      setCount((prevCount) => {
        const nextCount = Math.min(prevCount + 1, targetCount);
        localStorage.setItem("currentCount", nextCount.toString());
        return nextCount;
      });
    }, stepDuration);

    if (count >= targetCount) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [count]);

  if (!isSmallScreen) return null;

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>In The Last 30 Days, We <br /> Have Paid Our Users:</h2>
      <div style={styles.counterWrapper}>
        <div style={styles.currencySymbol}>₹</div>
        {count
          .toString()
          .split("")
          .map((digit, index) => (
            <div key={index} style={styles.counterBox}>
              {digit}
            </div>
          ))}
      </div>
    </div>
  );
};

const styles = {
    container: {
      display: "flex",
      flexDirection: "column" as const,
      justifyContent: "center",
      alignItems: "center", 
      textAlign: "center" as const,
      padding: "10px 20px",
      backgroundcolor: "#000000",
      borderRadius: "16px",
      color: "#000",
      margin: "0 auto",
      width: "100%",
    },
    heading: {
      fontSize: "22px",
      fontWeight: 700,
      marginBottom: "8px",
      lineHeight: "1.3",
      color: "#ffffff", // Dark Blue for heading
      fontFamily: ' "Plus Jakarta Sans", sans-serif',
    },
    counterWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "transparent",
      padding: "0",
    },
    currencySymbol: {
      fontSize: "24px",
      fontWeight: 700,
      color: "#C9F23C", // Yellow symbol
      marginRight: "4px",
    },
    counterBox: {
      fontSize: "20px",
      fontWeight: 700,
      color: "#000000", // White text
      backgroundColor: "#C9F23C", // Yellow background
      borderRadius: "4px",
      width: "30px",
      height: "42px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 3px",
      boxShadow: "none",
    },
  };
  

export default CounterSection;


